module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26.35 18c1.12 0 2.248-.87 2.518-1.94L31.94 1.94C32.212.87 31.526 0 30.404 0H2.028C.906 0 0 .894 0 2s.906 2 2.028 2H4v20c0 1.106.96 2 2.082 2H28c1.12 0 2-.894 2-2s-.88-2-2-2H8v-4h18.35zM12 29a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm16 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cart-3.js
// module id = 1050
// module chunks = 14